import ExpandOutlinedIcon from "@mui/icons-material/ExpandOutlined";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import VerticalAlignBottomOutlinedIcon from "@mui/icons-material/VerticalAlignBottomOutlined";
import { Box, ListItemIcon, MenuItem } from "@mui/material";
import { FC, useRef } from "react";

import MoreMenu, { MoreMenuHandle } from "../../Misc/MoreMenu";
import { useTranslation } from "react-i18next";

export interface CastField {
  columnMetadataFieldId: number;
  placeholderRowId: number;
  isApplicable: boolean;
  isMandatory: boolean;
  isValueSettable: boolean;
  isErrored: boolean;
  predefinedValues: string[];
  onChange: any;
  value: any;
}

export type MoreMenuFieldWrapperProps = {
  onReset?: (index: number, field: string) => void;
  onUpdateAllRows?: (value: any, field: string) => void;
  onUpdateRowsBelow?: (value: any, index: number, field: string) => void;
  value: any;
  index: number;
  field: string;
};

const MoreMenuFieldWrapper: FC<MoreMenuFieldWrapperProps> = (props) => {
  const { t } = useTranslation();
  const { field, onReset, onUpdateAllRows, onUpdateRowsBelow, index, value } = props;

  const moreMenuRef = useRef<MoreMenuHandle>(null);

  return (
    <>
      {(onUpdateAllRows || onReset || onUpdateRowsBelow) && (
        <Box id="tutorial-request-menu">
          <MoreMenu
            ref={moreMenuRef}
            className={"MoreMenuClass"}
            direction="vertical"
            size="small"
            sx={{ color: "text.secondary" }}
          >
            {onUpdateRowsBelow && (
              <MenuItem
                onClick={() => {
                  moreMenuRef.current?.closeMenu();
                  onUpdateRowsBelow(value, index, field);
                }}
                disabled={!value}
              >
                <ListItemIcon>
                  <VerticalAlignBottomOutlinedIcon />
                </ListItemIcon>
                {t("menu:item.updateRowsBelow")}
              </MenuItem>
            )}
            {onUpdateAllRows && (
              <MenuItem
                onClick={() => {
                  moreMenuRef.current?.closeMenu();
                  onUpdateAllRows(value, field);
                }}
                disabled={!value}
              >
                <ListItemIcon>
                  <ExpandOutlinedIcon />
                </ListItemIcon>
                {t("menu:item.updateAllTheColumn")}
              </MenuItem>
            )}
            {onReset && (
              <MenuItem
                onClick={() => {
                  moreMenuRef.current?.closeMenu();
                  onReset(index, field);
                }}
              >
                <ListItemIcon>
                  <UpdateOutlinedIcon />
                </ListItemIcon>
                {t("panel:newRequestFiltersPanel.resetToDefaultLink")}
              </MenuItem>
            )}
          </MoreMenu>
        </Box>
      )}
    </>
  );
};

export default MoreMenuFieldWrapper;
